import produce from 'immer'
import { createAsyncObject } from '@jarvis.oddle/core/tools/redux/action'
import { updateForAsyncRequest, updateForAsyncSuccess, updateForAsyncFailure } from '@jarvis.oddle/core/tools/redux/reducer'
import * as C from './constants'

export const initialState = {
  checkoutResults: createAsyncObject({}),
  validateTokenResults: createAsyncObject({}),
  trackingDeliveryResults: createAsyncObject({})
}

export const reducers = (state = initialState, action) => produce(state, draftState => {
  switch (action.type) {
    case C.GET_CHECKOUT_RESULTS_REQUEST: updateForAsyncRequest(draftState.checkoutResults); break
    case C.GET_CHECKOUT_RESULTS_SUCCESS: updateForAsyncSuccess(action.payload)(draftState.checkoutResults); break
    case C.GET_CHECKOUT_RESULTS_FAILURE: updateForAsyncFailure(action)(draftState.checkoutResults); break
    case C.GET_VALIDATE_TOKEN_REQUEST: updateForAsyncRequest(draftState.validateTokenResults); break
    case C.GET_VALIDATE_TOKEN_SUCCESS: updateForAsyncSuccess(action.payload)(draftState.validateTokenResults); break
    case C.GET_VALIDATE_TOKEN_FAILURE: updateForAsyncFailure(action)(draftState.validateTokenResults); break
    case C.GET_DELIVERY_TRACKING_LINK_REQUEST: updateForAsyncRequest(draftState.trackingDeliveryResults); break
    case C.GET_DELIVERY_TRACKING_LINK_SUCCESS: updateForAsyncSuccess(action.payload)(draftState.trackingDeliveryResults); break
    case C.GET_DELIVERY_TRACKING_LINK_FAILURE: updateForAsyncFailure(action)(draftState.trackingDeliveryResults); break
  }
})
